module.exports = __webpack_public_path__ + "img/284.4da2a5cc.png";